// extracted by mini-css-extract-plugin
export default {"ticketContainer":"ZJO4oC","ticketInnerContainer":"wCgOhC","ticketInfoContainer":"z4QTEL","priceQuantityContainer":"O_h7oJ"};